import BadgeActivityContainer from './BadgeActivity.container';
import BadgeActivity from './BadgeActivity';
export default BadgeActivityContainer(BadgeActivity);
